import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../../components/ui/Header';
import Breadcrumb from '../../../components/ui/Breadcrumb';
import DeploymentPointModal from './DeploymentPointModal';
import Button from '../../../components/ui/Button';
import httpHelper, { Method_TYPE } from 'utils/http-helper';
import URL_CONSTANTS from 'constants/url-constants';
import DataTable from 'react-data-table-component';
import Select from '../../../components/ui/Select';

const DeploymentPointPage = () => {
  const [deploymentDetails, setDeploymentDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedPoint, setSelectedPoint] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filterOption, setFilterOption] = useState([]);
  const [filterStatus, setFilterStatus] = useState('');
  const [rawDeploymentDetails, setRawDeploymentDetails] = useState([]);

  useEffect(() => {
    fetchDeploymentPoints();
  }, []);

 const fetchDeploymentPoints = async () => {
  try {
    setFilterStatus('');
    const data = await httpHelper(`${URL_CONSTANTS.MANAGE_DEPLOYNENT_POINTS}`, Method_TYPE.GET);
    console.log("fetch data",data)
    const formattedData = data?.data?.map((tableData, index) => ({
      slno: index + 1,
      id: tableData?._id, // Add ID or primary key here
      deploymentpoint: tableData?.name,
      description: tableData?.description,
      sector: tableData?.sector?.name,
      requestCount: tableData?.reqCount,
    }));

    setRawDeploymentDetails(formattedData);
    setDeploymentDetails(formattedData);
    setFilterOption(data?.data?.map(tableData => tableData?.name));
  } catch (err) {
    console.log("Fetch deploy points api err", err);
  }
};


  const handleAddNew = () => {
    setSelectedPoint(null);
    setIsModalOpen(true);
  };
const handleEdit = (row) => {

  let editValue = deploymentDetails?.filter(detail=> detail?.id === row)
  setSelectedPoint(editValue);
  setIsModalOpen(true);
};

 const handleFilter = (e) => {
  setFilterStatus(e);
  const filtered = e
    ? rawDeploymentDetails.filter(detail => detail.deploymentpoint === e)
    : rawDeploymentDetails;

  setDeploymentDetails(filtered);
};

const columns = [
  {name: 'Sl.No',selector: row => row.slno,sortable: true,cell: row => <div data-title="Sl.No">{row.slno}</div>,},
  {name: 'Deployment Point',selector: row => row.deploymentpoint,sortable: true,cell: row => <div data-title="Deployment Point">{row.deploymentpoint}</div>,},
  {name: 'Description',selector: row => row.description,sortable: true,cell: row => <div data-title="Description">{row.description}</div>,},
  {name: 'Sector',selector: row => row.sector,sortable: true,cell: row => <div data-title="Sector">{row.sector}</div>,},
  {name: 'Request Count',selector: row => row.requestCount,sortable: true,cell: row => <div data-title="Request Count">{row.requestCount}</div>,},
  {name: 'Actions',cell: row => (
      <div data-title="Actions">
         <Button
          variant="ghost"
          size="sm"
          iconSize="16"
          onClick={() => handleEdit(row.id)}
          iconName="Edit"
          iconPosition="left"
            >
            <span className='inline-block lg:inline-block'>Edit</span>                  
          </Button>
      </div>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
  },
];

  // Filter deploymentDetails based on filterStatus
 

  return (
    <>
      <div className="p-4 text-center border-border bg-white bg-card border !rounded-lg shadow-spiritual-sm border-b-0 !rounded-bl-none !rounded-br-none relative">
        <div className="flex justify-between mb-0 md:flex-row flex-col">
          <Select
            placeholder="Filter by Deployment Point"
            options={filterOption.map(option => ({ value: option, label: option }))}
            value={filterStatus}
            onChange={(e) => handleFilter(e)}
          />
          <div className='flex mt-2 md:mt-0 justify-end'>
            <button type='button' className='inline-flex md:h-full mr-4 w-36 items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input hover:bg-gray-500 hover:text-white text-white rounded-md bg-gray-400 px-3' 
          onClick={fetchDeploymentPoints}>Refresh</button>
          <button type='button' className='hover:text-accent-foreground w-36 max-w-32 inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-accent h-10 px-4 py-2'
           onClick={handleAddNew}>Add</button>
          </div>
        </div>
      </div>

      <DataTable
        columns={columns}
        data={deploymentDetails}
        fixedHeader
        fixedHeaderScrollHeight='500px'
        defaultSortFieldId={1}
        className='reports-table'
        responsive
      />

      <DeploymentPointModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        deploymentPoint={selectedPoint}
        fetchDeploymentPoints= {fetchDeploymentPoints}
      />
    </>
  );
};

export default DeploymentPointPage;
